// Allow for either one or more comparisionProperty when doing validation against lists

export function comparisonProperties(field) {
    const comparisonProperty = field ? field.comparisonProperty : null;

    if (Array.isArray(comparisonProperty)) {
        return comparisonProperty.length > 0 ? comparisonProperty : ['text'];
    }

    return [comparisonProperty ?? 'text'];
}

export function comparisonProperty(field) {
    return comparisonProperties(field)[0];
}

export function matchesComparisonValue(option, field, value) {
    if (!option) {
        return false;
    }

    const importedValue = (value + '').toLocaleLowerCase();

    return comparisonProperties(field).some(property => {
        const optionValue = option[property];
        if (optionValue === undefined || optionValue === null || optionValue === '') {
            return false;
        }
        return (optionValue + '').toLocaleLowerCase() === importedValue;
    });
}
